import React from 'react';

/**
 * ContentHeader - V4 styled page header with icon badge
 *
 * @param {node} icon - Icon or emoji to display in badge
 * @param {string} title - Main title
 * @param {string} subtitle - Description text
 * @param {string} metadata - Additional info (e.g., "5 projects · $50k revenue")
 * @param {node} actions - Action buttons
 */
const ContentHeader = ({ icon, title, subtitle, metadata, actions }) => (
  <header className="v4-content-header">
    <div className="v4-content-header__left">
      {icon && <div className="v4-content-header__icon">{icon}</div>}
      <div className="v4-content-header__text">
        <h1 className="v4-content-header__title">{title}</h1>
        {subtitle && <p className="v4-content-header__subtitle">{subtitle}</p>}
        {metadata && <p className="v4-content-header__metadata">{metadata}</p>}
      </div>
    </div>
    {actions && <div className="v4-content-header__actions">{actions}</div>}
  </header>
);

export default ContentHeader;
